module.exports = __webpack_public_path__ + "static/media/bitcoin_network.b972c20c.mp4";